// declare var moment: any;

import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
const moment = moment_;

export class DateFormatter {
  public format(date: Date, format: string): string {
    return moment(date.getTime()).format(format);
  }
}
